import { useEffect, useRef } from "react";
import EngravingScene from "./EngravingScene";
import { ENGRAVING_INSOLE_MESH_NAMES } from "../../../constants/insole-models";
import { FOAM_PACKAGE_SHOPIFY_OPTIONS, FOAM_PACKAGE_TYPES, FoamPackageType } from "../../../constants/foot";
import { useApp } from "../../../context/AppContext";

const Personilzation3DModelMain = ({
  leftText,
  rightText,
  selectedFoamPackageOption = FOAM_PACKAGE_SHOPIFY_OPTIONS['superrev'],
  ribbingLevel = 0
}: {
  leftText: string;
  rightText: string;
  selectedFoamPackageOption?: string;
  ribbingLevel?: number;
}) => {
  const leftTextRef = useRef<string>(leftText);
  const rightTextRef = useRef<string>(rightText);

  useEffect(() => {
    leftTextRef.current = leftText;
    rightTextRef.current = rightText;
  }, [leftText, rightText]);

  const { foamPackageShopifyOptions } = useApp();
  const foamPackageType: FoamPackageType = selectedFoamPackageOption.toLowerCase() === foamPackageShopifyOptions[FOAM_PACKAGE_TYPES.SUPERREV].toLowerCase() ? FOAM_PACKAGE_TYPES.SUPERREV : FOAM_PACKAGE_TYPES.SUPERREV_ELITE;
  const engravingInsoleMeshNames = ENGRAVING_INSOLE_MESH_NAMES[foamPackageType];

  // EngravingScene portals its R3F content into the app-wide PersistentCanvas
  // via sceneTunnel.In, so no <Canvas> is needed at this level.
  return (
    <EngravingScene
      foamPackageType={foamPackageType}
      leftTextRef={leftTextRef}
      rightTextRef={rightTextRef}
      engravingInsoleMeshNames={engravingInsoleMeshNames}
      ribbingLevel={ribbingLevel}
    />
  );
};

export default Personilzation3DModelMain;
